module.exports = __webpack_public_path__ + "img/bg_avatar_male_05.61da7ffa.png";